export function getErrorMessage(error) {
  if (!error) return "An unknown error occurred.";

  if (error.response && error.response.data) {
    return extractMessages(error.response.data);
  }

  if (typeof error === "object") {
    return extractMessages(error);
  }

  if (typeof error === "string") return error;


  if (error.message) return error.message;

  return "Something went wrong. Please try again.";
}

function extractMessages(data) {
  // {"detail": "Invalid credentials"}
  if (data.detail) return data.detail;


  if (typeof data === "object") {
    const messages = [];

    Object.entries(data).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        messages.push(value.join(", "));
      } else if (typeof value === "string") {
        messages.push(value);
      }
    });

    if (messages.length > 0) return messages.join(" | ");
  }

  return null;
}
